import { render, staticRenderFns } from "./ShipmentApply.vue?vue&type=template&id=04ad322e&scoped=true&"
import script from "./ShipmentApply.vue?vue&type=script&lang=js&"
export * from "./ShipmentApply.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentApply.vue?vue&type=style&index=0&id=04ad322e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ad322e",
  null
  
)

export default component.exports